import { render, staticRenderFns } from "./RoleMenuAssignDialog.vue?vue&type=template&id=1598b0fc&scoped=true&"
import script from "./RoleMenuAssignDialog.vue?vue&type=script&lang=js&"
export * from "./RoleMenuAssignDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleMenuAssignDialog.vue?vue&type=style&index=0&id=1598b0fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1598b0fc",
  null
  
)

export default component.exports